import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { carTestLabels } from "@/i18n";

interface WindshieldSectionProps {
  windshield: { problem?: string; description?: string } | null;
  onWindshieldChange: (windshield: {
    problem?: string;
    description?: string;
  }) => void;
  onNext: () => void;
}

export const WindshieldSection = ({
  windshield,
  onWindshieldChange,
  onNext,
}: WindshieldSectionProps) => {
  const [description, setDescription] = useState(windshield?.description || "");
  const { language } = useLanguage();
  const ct = carTestLabels(language);
  const form = ct.form ?? {};
  const v = ct.pdf?.values ?? ({} as Record<string, string>);

  const handleResultChange = (problem: string) => {
    if (problem === "no" || problem === "stone_chip") {
      onWindshieldChange({ problem });
      onNext();
    } else {
      onWindshieldChange({ problem, description: undefined });
      setDescription("");
    }
  };

  const handleDescriptionChange = (text: string) => {
    setDescription(text);
  };

  const handleNextClick = () => {
    onWindshieldChange({ ...windshield, description });
    onNext();
  };

  const showNextButton = windshield?.problem === "yes" && description.trim();

  // Don't show description input for stone_chip
  const showDescriptionInput = windshield?.problem === "yes";

  return (
    <div className="space-y-4">
      <div>
        <h4 className="font-medium text-sm mb-3">{form.questionWindshield}</h4>
        <div className="grid grid-cols-3 gap-1.5 mb-4">
          <Button
            onClick={() => handleResultChange("yes")}
            variant="formOption"
            className={`${
              windshield?.problem === "yes"
                ? "border-accent border-2"
                : "border-gray-400"
            }`}
          >
            {v.yes}
          </Button>
          <Button
            onClick={() => handleResultChange("no")}
            variant="formOption"
            className={`${
              windshield?.problem === "no"
                ? "border-accent border-2"
                : "border-gray-400"
            }`}
          >
            {v.no}
          </Button>
          <Button
            onClick={() => handleResultChange("stone_chip")}
            variant="formOption"
            className={`${
              windshield?.problem === "stone_chip"
                ? "border-accent border-2"
                : "border-gray-400"
            }`}
          >
            {v.stoneChip}
          </Button>
        </div>

        {showDescriptionInput && (
          <div className="space-y-3">
            <div className="space-y-2">
              <Input
                type="text"
                placeholder={form.placeholderDescribeCrack}
                value={description}
                onChange={(e) => handleDescriptionChange(e.target.value)}
                className="w-full"
                required
              />
            </div>
          </div>
        )}

        {showNextButton && (
          <Button className="w-full mt-4" onClick={handleNextClick}>
            {form.next}
          </Button>
        )}
      </div>
    </div>
  );
};
